'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var palette = {
    black: '#000000',
    white: '#FFFFFF',
    red: ['#F9DEDC', '#F0ADA8', '#E77B73', '#DE4A3F', '#C6413E'],
    orange: ['#FFE9D6', '#FFD3AD', '#FFB370', '#FF9231', '#F57200'],
    yellow: ['#F7F4EA', '#FFF1B2', '#FAE27A', '#FFD002', '#F0C300', '#DBB100'],
    green: ['#D9FEFF', '#ABF9F2', '#73E8DE', '#23D5C6', '#0B887E'],
    turquoise: ['#E3F2F2', '#BADEDE', '#9ED0D1', '#4EA4A6', '#22A0AC', '#1C7E87'],
    blue: ['#DCEFF9', '#95CFEE', '#5FB8E7', '#2199D9', '#1870A0'],
    purple: ['#E6E5F0', '#B5B1D3', '#847CB6', '#675EA5', '#514983'],
    pink: ['#FFEFF4', '#FFD0DF', '#F2A6BE', '#EC799D', '#D0577D'],
    brown: ['#9B803D', '#8E652A', '#5B4028', '#473A31', '#2D241D', '#1C1616'],
    neutral: [
        '#F4F5F5',
        '#EAECEC',
        '#DFE2E2',
        '#C9CECF',
        '#A9B1B2',
        '#889496',
        '#697577',
        '#4D5556',
        '#303536',
        '#222222',
    ],
};
var colors = {
    white: palette.white,
    black: palette.black,
    current: 'currentColor',
    transparent: 'transparent',
    neutral: {
        DEFAULT: palette.neutral[4],
        50: palette.neutral[0],
        100: palette.neutral[1],
        200: palette.neutral[2],
        300: palette.neutral[3],
        400: palette.neutral[4],
        500: palette.neutral[5],
        600: palette.neutral[6],
        700: palette.neutral[7],
        800: palette.neutral[8],
        900: palette.neutral[9],
    },
    red: {
        DEFAULT: palette.red[3],
        100: palette.red[0],
        300: palette.red[1],
        500: palette.red[2],
        700: palette.red[3],
        900: palette.red[4],
    },
    orange: {
        DEFAULT: palette.orange[3],
        100: palette.orange[0],
        300: palette.orange[1],
        500: palette.orange[2],
        700: palette.orange[3],
        900: palette.orange[4],
    },
    yellow: {
        DEFAULT: palette.yellow[3],
        50: palette.yellow[0],
        100: palette.yellow[1],
        300: palette.yellow[2],
        500: palette.yellow[3],
        700: palette.yellow[4],
        900: palette.yellow[5],
    },
    green: {
        DEFAULT: palette.green[3],
        100: palette.green[0],
        300: palette.green[1],
        500: palette.green[2],
        700: palette.green[3],
        900: palette.green[4],
    },
    turquoise: {
        DEFAULT: palette.turquoise[4],
        100: palette.turquoise[0],
        300: palette.turquoise[1],
        500: palette.turquoise[2],
        600: palette.turquoise[3],
        700: palette.turquoise[4],
        900: palette.turquoise[5],
    },
    blue: {
        DEFAULT: palette.blue[3],
        100: palette.blue[0],
        300: palette.blue[1],
        500: palette.blue[2],
        700: palette.blue[3],
        900: palette.blue[4],
    },
    purple: {
        DEFAULT: palette.purple[3],
        100: palette.purple[0],
        300: palette.purple[1],
        500: palette.purple[2],
        700: palette.purple[3],
        900: palette.purple[4],
    },
    pink: {
        DEFAULT: palette.pink[3],
        100: palette.pink[0],
        300: palette.pink[1],
        500: palette.pink[2],
        700: palette.pink[3],
        900: palette.pink[4],
    },
    brown: {
        DEFAULT: palette.brown[3],
        50: palette.brown[0],
        100: palette.brown[1],
        300: palette.brown[2],
        500: palette.brown[3],
        700: palette.brown[4],
        900: palette.brown[5],
    },
};

var typography = {
    standard: 'Lato',
};

var theme = {
    colors: colors,
    extend: {
        screens: {
            xxs: '320px',
            xs: '425px',
            // Widget mobile breakpoint
            wm: '500px',
        },
        fontSize: {
            xxs: [
                '.5rem',
                {
                    lineHeight: '0.75rem',
                },
            ],
        },
        fontFamily: {
            sans: [typography.standard, 'sans-serif'],
            circular: ['Circular Std', 'Arial', 'san-serif'],
        },
        boxShadow: {
            top: '0 -4px 4px 0 rgba(166, 166, 166, 0.13)',
            around: '0 1px 10px 0 rgba(0, 0, 0, 0.1)',
        },
        zIndex: {
            '99': 99,
        },
        spacing: {
            '30': '7.5rem',
            '37': '9.375rem',
        },
        animation: {
            'fade-in': 'fade-in .5s linear forwards',
            'fade-out': 'fade-out .5s linear forwards',
            'fade-in-down': 'fade-in-down .5s linear 1',
            'fade-in-up': 'fade-in-up .5s linear 1',
            'fade-in-left': 'fade-in-left .5s linear 1',
            'fade-in-right': 'fade-in-right .5s linear 1',
            'rotate-360': 'rotate-360 2s linear infinite',
        },
        keyframes: {
            'rotate-360': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' },
            },
            'fade-in': {
                '0%': { opacity: '0' },
                '100%': { opacity: '1' },
            },
            'fade-out': {
                '0%': { opacity: '1' },
                '100%': { opacity: '0' },
            },
            'fade-in-down': {
                '0%': { opacity: '0', transform: 'translateY(-20px)' },
                '100%': { opacity: '1', transform: 'translateY(0)' },
            },
            'fade-in-up': {
                '0%': { opacity: '0', transform: 'translateY(20px)' },
                '100%': { opacity: '1', transform: 'translateY(0)' },
            },
            'fade-in-left': {
                '0%': { opacity: '0', transform: 'translateX(-20px)' },
                '100%': { opacity: '1', transform: 'translateX(0)' },
            },
            'fade-in-right': {
                '0%': { opacity: '0', transform: 'translateX(20px)' },
                '100%': { opacity: '1', transform: 'translateX(0)' },
            },
        },
    },
};

exports.colors = colors;
exports.theme = theme;
